module.exports = __webpack_public_path__ + "static/media/remove.f15dc19f.svg";